import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadAdjustmentListAfterCreateEpic } from './_epics/loadAdjustmentListAfterCreate.epic';
import { closeDetailsSidebarEpic } from './_epics/closeDetailsSidebar.epic';
import { closeDetailsSidebarAfterRemoveEpic } from './_epics/closeDetailsSidebarAfterRemove.epic';

export const controllerAdjustmentProfileEpic = safeCombineEpics(
  loadAdjustmentListAfterCreateEpic,
  closeDetailsSidebarEpic,
  closeDetailsSidebarAfterRemoveEpic,
);
